<!--
 * @Author: guoyu
 * @Date: 2021-04-20 11:53:30
 * @LastEditors: your name
 * @LastEditTime: 2021-04-26 17:13:29
 * @Description: 展示邀請用戶信息
-->
<template>
  <div>
    <GTable
      class="invite-list"
      :headOptions="headOptions"
      :options="disPlayList"
    >
      <template v-slot:avatar="{ trInfo }">
        <div class="invite-user" @click="gotoDetail(trInfo)">
          <fps-avatar
            class="invite-avatar"
            :src="trInfo.avatarUrl"
          ></fps-avatar>
          <span class="nick-name">{{ trInfo.nickName }}</span>
        </div>
      </template>
      <template v-slot:time="{ val }">
        <span>{{ new Date(val).$format('yyyy-MM-dd') }}</span>
      </template>
      <template v-slot:award="{ val }">
        <div class="award" :class="{ 'has-award': val * 1 }">{{ val }}幣</div>
      </template>
    </GTable>
    <div class="show-more" v-if="!noMore">
      <span class="more-text" v-if="!isLoading" @click="pageAdd">查看更多</span>
      <div v-else><i class="el-icon-loading"></i></div>
    </div>
  </div>
</template>
<script>
import GTable from '@/components/common/table';
export default {
  components: {
    GTable
  },
  model: {
    event: 'change',
    prop: 'val'
  },
  props: ['val'],
  data() {
    return {
      inviteList: [],
      headOptions: [
        {
          name: 'avatar',
          label: '用戶'
        },
        {
          name: 'time',
          label: '註冊時間',
          key: 'createTime'
        },
        {
          name: 'award',
          label: '帶來獎勵',
          key: 'cumulativeReward'
        }
      ],
      pageIndex: 0,
      total: 0,
      isLoading: false
    };
  },
  computed: {
    noMore() {
      return this.disPlayList.length >= this.total;
    },
    // 數據未做分頁排序，故由前端排序
    disPlayList() {
      return this.inviteList.slice(0, (this.pageIndex+1)*6)
    }
  },
  methods: {
    /**
     * @description: 獲取邀請人列
     * @param {*}
     * @return {*}
     */
    getInviteList() {
      if (this.isLoading) return;
      this.isLoading = true;
      this.$http
        .post('/signUp/listInvitedUserInfo', {
          pageIndex: this.pageIndex,
          pageSize: 2000
        })
        .then(({ data }) => {
          this.total = data.totalRemain;
          this.inviteList = this.inviteList.concat(data.pageContent).sort((a, b)=>{
            let firstQue = b.cumulativeReward - a.cumulativeReward
            // 按获利大小排序
            if (firstQue) return firstQue
            // 按时间排序
            return b.createTime - a.createTime
          });
          this.isLoading = false;
          this.$emit('change', this.total);
        })
        .catch(e => {
          console.error(e);
          this.isLoading = false;
          this.$toast('請求失敗');
        });
    },
    gotoDetail(inviteUser) {
      this.$util.openWindow(`/player-detail/${inviteUser.userUuid}`);
    },
    pageAdd() {
      this.pageIndex++;
    }
  },
  created() {
    this.getInviteList();
  }
};
</script>
<style lang="scss" scoped>
.invite-list {
  width: 100%;
  margin: 12px 0 24px;
  font-size: 12px;
  color: #44072e;
  background: linear-gradient(
    180deg,
    rgba(255, 232, 229, 0.52) 0%,
    rgba(255, 232, 229, 0) 100%
  );
  /deep/ .th-default,
  /deep/.td-default {
    height: 44px;
    border: none;
    vertical-align: middle;
    text-align: left;
    color: #44072e;
    &:last-child {
      padding-right: 12px;
      text-align: right;
    }
    &:first-child {
      padding-left: 12px;
    }
  }
  /deep/ .thead-default {
    text-align: left;
    .th-default {
      color: #44072e80;
    }
  }
}
.invite-user {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  cursor: pointer;
}
.invite-avatar {
  height: 28px;
  width: 28px;
  overflow: hidden;
  flex-grow: 0;
  flex-shrink: 0;
  margin-right: 16px;
  &.avatar-gif {
    height: 28px !important;
    width: 28px !important;
  }
}
.nick-name {
  display: inline-block;
  width: 100px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.award {
  width: 100%;
  text-align: right;
}
.has-award {
  color: #e75706;
}
.show-more {
  text-align: center;
  font-size: 12px;
  line-height: 18px;
  color: #d32942;
}
.more-text {
  cursor: pointer;
}
</style>
